import { FT, Spine } from 'ft'

const $SPINE_YI = 'spine.YI'
const $SPINE_MD = 'spine.MD'
const $SPINE_NEEKO = 'spine.Neeko'
const $SPINE_AKL = 'spine.AKL'
const $SPINE_LS = 'spine.LS'
const $SPINE_SLK = 'spine.SLK'

FT.rm.addSpine($SPINE_YI)
FT.rm.addSpine($SPINE_MD)
FT.rm.addSpine($SPINE_NEEKO)
FT.rm.addSpine($SPINE_AKL)
FT.rm.addSpine($SPINE_LS)
FT.rm.addSpine($SPINE_SLK)

const map = {
  yi: $SPINE_YI,
  md: $SPINE_MD,
  neeko: $SPINE_NEEKO,
  akl: $SPINE_AKL,
  ls: $SPINE_LS,
  slk: $SPINE_SLK,
}

class Hero extends Spine {
  constructor(heroId, temp) {
    super(FT.rm.spine(map[heroId]))
    this.scale.set(0.5, 0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)

    this.render(heroId, temp)
  }

  render(heroId, temp) {
    let skin, animation

    if (temp >= 31) {
      skin = 'Heat'
      animation = 'SC05_Heat_Loop'
    } else if (temp >= 21 && temp <= 30) {
      skin = 'Normal'
      animation = 'SC05_Breath_Loop'
    } else if (temp >= 11 && temp <= 20) {
      skin = 'Melt'
      animation = 'SC05_Breath_Loop'
    } else {
      skin = 'Freeze'
      animation = 'Freeze_Loop'
    }

    this.skeleton.setSkinByName(skin)
    this.skeleton.setSlotsToSetupPose()
    const playingAnimation = this.state.setAnimation(0, animation, true)

    // pause animation if animation is Freeze_Loop
    if (animation === 'Freeze_Loop') {
      playingAnimation.timeScale = 0
    } else {
      playingAnimation.timeScale = 1
    }
  }
}

export default Hero
